module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": 'imbee-' + _vm.animation
    }
  }, [(_vm.show && !_vm.opened && !_vm.showCta) ? _c('div', {
    staticClass: "imbee-bubble-text-badge",
    style: ({
      backgroundColor: _vm.backgroundColor
    })
  }, [_c('span', {
    style: ({
      fontWeight: _vm.fontWeight,
      fontSize: _vm.fontSize,
      fontFamily: _vm.fontFamily,
      color: _vm.color,
    })
  }, [_vm._v(_vm._s(_vm.text))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a5894a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextBadge.vue
// module id = 216
// module chunks = 0 1